import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const getNearByNeighbors = createAsyncThunk("getNearByNeighbors", async (data) => {
    try {
        const response = await axiosInstance.get(`/location/nearby/`);
        const result = response.data;
        return result

    } catch (error) {
        console.error("Error:", error.response.data);
    }
});

export const getNearByNeighborsByLocation = createAsyncThunk("getNearByNeighborsByLocation", async (data = "") => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/get_friends_in_same_postcode/?search=${data}`);
        const result = response.data;
        return result
    }
    catch (error) {
        console.error("Error:", error.response.data);
    }
});

export const getNearByNeighborsByLocationWithPostcode = createAsyncThunk("getNearByNeighborsByLocationWithPostcode", async (data = "") => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/neighbors/?page=${data.page}`);
        const result = response.data;
        return result
    } catch (error) {
        console.error("Error:", error.response.data);
    }
});


export const NeighborhoodSlice = createSlice({
    name: "Neighborhood",
    initialState: {
        neighborhood: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // getNearByNeighbors action promises
        builder.addCase(getNearByNeighbors.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getNearByNeighbors.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhood = action.payload;
        });
        builder.addCase(getNearByNeighbors.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(getNearByNeighborsByLocation.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getNearByNeighborsByLocation.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhood = action.payload;
        });
        builder.addCase(getNearByNeighborsByLocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        builder.addCase(getNearByNeighborsByLocationWithPostcode.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getNearByNeighborsByLocationWithPostcode.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhood = action.payload;
        });
        builder.addCase(getNearByNeighborsByLocationWithPostcode.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default NeighborhoodSlice.reducer;